/* eslint-disable no-throw-literal */
import apiClient from './apiClient.js';

export const getAppKeywords = () => apiClient.get('/keywords');
export const getAppKeywordById = (id) => apiClient.get(`/keywords/${id}`);
export const getAppKeywordDomainById = (id) => apiClient.get(`/keywords/domain/${id}`);
export const getAppKeywordNameById = (id) => apiClient.get(`/keywords/keyword-name/${id}`);
export const getAppKeywordsAll = () => apiClient.get('/keywords/all');
export const getAppKeywordsAllById = (id) => apiClient.get(`/keywords/all/${id}`);
export const updateAppKeyword = (id, data) => apiClient.put(`/keywords/${id}`, data);
export const deleteAppKeyword = (id) => apiClient.delete(`/keywords/${id}`);
export const deleteAppKeywordAll = (id) => apiClient.delete(`/keywords/all/${id}`);

export const createAppKeyword = async (data) => {
  try {
    const response = await apiClient.post('/keywords', data);
    return response.data;
  } catch (error) {
    if (error.response) {
      if (error.response.status === 409) {
          throw { type: 'duplicate', message: error.response.data?.error || 'El keyword ya existe.' };
      }
      throw { type: 'general', message: error.response.data?.error || 'Ha ocurrido un error, por favor intente nuevamente.' };
    }
    throw { type: 'general', message: 'Error de conexión, por favor intente nuevamente.' };
  }
};
